export const getUnderlyingInvestmentLink = (
  hostname,
  channel,
  xid,
  fundType
) => {
  if (hostname && channel && xid) {
    // Host names
    let hostNameInLink = '';
    const TIAA_ORG_HOST = 'www.tiaa.org';
    const TIAA_PRIVATE_ORG_HOST = 'shared.tiaa.org';
    const TIAA_ORIGIN_HOST = 'origin-www-at.test.tiaa.org';
    const TIAA_PRIVATE_ORIGIN_HOST = 'origin-shared-st2.test.tiaa.org';

    // Path Prefix
    const formattedChannel = channel.toLowerCase();
    const PRIVATE_CHANNELS = ['mytiaa'];

    const isPrivateHost =
      hostname === TIAA_PRIVATE_ORG_HOST ||
      hostname === TIAA_PRIVATE_ORIGIN_HOST;
    const isPublicHost =
      hostname === TIAA_ORG_HOST || hostname === TIAA_ORIGIN_HOST;
    const isPrivateUrl =
      !isPublicHost &&
      (PRIVATE_CHANNELS.includes(formattedChannel) || isPrivateHost);
    const pathPrefix = isPrivateUrl ? 'private/parttools' : 'public';

    // Get hostNameInLink
    switch (hostname) {
      // Public Production
      case TIAA_ORG_HOST:
      case 'www.tiaa.markitondemand.com':
      case 'tiaa-research-web.ptc.services.mdgapp.net':
      case 'tiaa-research-web.ctc.services.mdgapp.net':
        hostNameInLink = TIAA_ORG_HOST;
        break;
      // Private Production
      case TIAA_PRIVATE_ORG_HOST:
        if (fundType === 'TIAA Stable Value') {
          hostNameInLink = TIAA_ORG_HOST;
        } else {
          hostNameInLink = TIAA_PRIVATE_ORG_HOST;
        }
        break;
      // Acceptance and Development
      case TIAA_ORIGIN_HOST:
      case 'localhost':
      case 'tiaa-research-web.dev.services.mdgapp.net':
      case 'tiaa-research-web.qa.services.mdgapp.net':
      case 'tiaa-research-web-a2.qa.services.mdgapp.net':
      case 'tiaa-research-web-a3.qa.services.mdgapp.net':
      case 'tiaa-research-web-a4.qa.services.mdgapp.net':
        if (fundType === 'TIAA Stable Value') {
          hostNameInLink = TIAA_ORIGIN_HOST;
        } else {
          hostNameInLink = isPrivateUrl
            ? TIAA_PRIVATE_ORIGIN_HOST
            : TIAA_ORIGIN_HOST;
        }
        break;
      /*
        Catch all for host names like:
          origin-shared-st2.test.tiaa.org, origin-shared-st4.test.tiaa.org,
          origin-www-st2.test.tiaa.org, origin-www-st4.test.tiaa.org
      */
      default:
        //TSVs are not supported on the legacy MyTIAA profile pages, I think once TSVs are released on redesign this TSV specific logic can be removed
        if (fundType === 'TIAA Stable Value') {
          switch (hostname) {
            case 'origin-shared-st4.test.tiaa.org':
              hostNameInLink = 'origin-www-st4.test.tiaa.org';
              break;
            case 'origin-shared-st2.test.tiaa.org':
              hostNameInLink = ' origin-www-st2.test.tiaa.org';
              break;
            default:
              hostNameInLink = hostname;
          }
        } else {
          hostNameInLink = hostname;
        }
    }
    //TODO: TSVs will need to be switched to the new profile URLs once that template is ready for prod
    return fundType === 'TIAA Stable Value'
      ? `https://${hostNameInLink}/public/investment-performance/tiaastablevalue/profile?ticker=${xid}`
      : `https://${hostNameInLink}/${pathPrefix}/investment-performance/investment/profile?ticker=${xid}`;
  }

  return '';
};
